module.exports = __webpack_public_path__ + "static/media/teachersnew.b22318fc.png";